import React from 'react';
import { ToastContainer, Flip } from 'react-toastify';
import { useTheme } from '../ThemeContext';

const ThemedToastContainer = () => {
    const { theme } = useTheme();

    return (
        <ToastContainer
            key={theme}
            position="top-center"
            autoClose={3000}
            limit={3}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={theme}
            transition={Flip}
            stacked
        />
    );
};

export default ThemedToastContainer;
